import React from 'react';
import './App.less';

import { 
  Button, 
  Layout, 
  Menu, 
  Typography 
} from 'antd';

import Home from './Home'
import WebHeader from './components/WebHeader'
import WebFooter from './components/WebFooter'
import ScrollToTop from './components/ScrollToTop'

import NewTen from './content/NewTen'
import FootUI from './content/FootUI'
import Chromoskyn from './content/Chromoskyn'
import Flow from './content/Flow'
import Pinaza from './content/Pinaza'
import Sc8r from './content/Sc8r'
import Sensable from './content/Sensable'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

const { Title } = Typography;

const { Header, Content, Footer } = Layout;

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          {/* <WebHeader /> */}
          <Content>
            <ScrollToTop>
              <Switch>
                <Route exact path="/">
                  <Home />
                </Route>
                <Route exact path="/content/NewTen">
                  <NewTen />
                </Route>
                <Route exact path="/content/FootUI">
                  <FootUI />
                </Route>
                <Route exact path="/content/Chromoskyn">
                  <Chromoskyn />
                </Route>
                <Route exact path="/content/Flow">
                  <Flow />
                </Route>
                <Route exact path="/content/Pinaza">
                  <Pinaza />
                </Route>
                <Route exact path="/content/Sc8r">
                  <Sc8r />
                </Route>
                <Route exact path="/content/Sensable">
                  <Sensable />
                </Route>
              </Switch>
            </ScrollToTop>
          </Content>
          <WebFooter />
        </Layout>
      </div>
    </Router>
  );
}

export default App;